import React, { useState } from 'react';

export default function CalendarArtistAvatar({ name, src }) {
  const [failedSource, setFailedSource] = useState(null);
  const initials = String(name || '').trim().split(/\s+/).filter(Boolean)
    .slice(0, 2).map(part => Array.from(part)[0]).join('').toUpperCase() || '?';
  return (
    <span className="calendar-artist-avatar" aria-hidden="true">
      {src && failedSource !== src ? (
        <img key={src} src={src} alt="" width="40" height="40" loading="lazy"
          decoding="async" onError={() => setFailedSource(src)} />
      ) : <span>{initials}</span>}
    </span>
  );
}
